<div class="dialog-container">

    <!-- STEP 1 -->
    <form *ngIf="step === 'mobile'" [formGroup]="mobileForm">
        <h2>Forgot Password</h2>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Mobile Number</mat-label>
            <input matInput formControlName="mobile" maxlength="10">
            <mat-error *ngIf="mobileForm.get('mobile')?.invalid">
                Enter valid mobile number
            </mat-error>
        </mat-form-field>

        <button mat-raised-button color="primary" (click)="sendOtp()" [disabled]="mobileForm.invalid">
            Generate OTP
        </button>
    </form>


    <!-- STEP 2 -->
    <form *ngIf="step === 'otp'" [formGroup]="otpForm">
        <h2>Verify OTP</h2>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Enter OTP</mat-label>
            <input matInput formControlName="otp" maxlength="6">
        </mat-form-field>

        <button mat-raised-button color="primary" (click)="verifyOtp()" [disabled]="otpForm.invalid" class="mb-2">
            Verify OTP
        </button>

        <button mat-raised-button color="accent" (click)="step = 'mobile'">Change Number</button>
    </form>


    <!-- STEP 3 -->
    <form *ngIf="step === 'password'" [formGroup]="passwordForm">
        <h2>Set New Password</h2>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Password</mat-label>
            <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password">
            <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button">
                <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Confirm Password</mat-label>
            <input matInput [type]="hideConfirm ? 'password' : 'text'" formControlName="confirmPassword">
            <button mat-icon-button matSuffix (click)="hideConfirm = !hideConfirm" type="button" class="eye-btn">
                <mat-icon>{{ hideConfirm ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>

            <!-- ✅ ERROR MESSAGE -->
            <mat-error *ngIf="passwordForm.hasError('mismatch') && passwordForm.get('confirmPassword')?.dirty">
                Passwords do not match
            </mat-error>
        </mat-form-field>

        <button mat-raised-button color="accent" (click)="resetPassword()" [disabled]="passwordForm.invalid">
            Update Password
        </button>
    </form>

</div>